// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"CloseButton","closeButtonIcon":"CloseButton-icon","closeButtonIconX":"CloseButton-iconX","closeButtonIconY":"CloseButton-iconY"};